import {
  AddressCollectionSchema,
  addressTypeSchema,
} from "@redotech/redo-model/address-collection";
import * as z from "zod/v4";

export const getAddressCollections = {
  name: "getAddressCollections" as const,
  input: z.object({ types: z.array(addressTypeSchema) }),
  output: z.object({ addresses: z.array(AddressCollectionSchema) }),
};
